import { FC, useState } from "react";
import toast from "react-hot-toast";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "shared/ui/shadcn/dialog";

import { glencocoClientAPI } from "@/api/glencoco";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { useFetchQualificationCriteriaAndPricing } from "@/api/routes/qualification-criteria/queries";
import { MarkMeetingForm } from "./mark-meeting-form";
import { QualificationTierI } from "shared/lib/interfaces/qualification-criteria";

import { swallow } from "@/api/legacy-swallow";

interface MarkMeetingModalPropsI {
  isOpen: boolean;
  onClose: () => void;
}

export const MarkMeetingModal: FC<MarkMeetingModalPropsI> = ({
  isOpen,
  onClose,
}) => {
  const { campaign, account, onAccountUpdate } = useAccountDetailsContext();

  const [isLoading, setIsLoading] = useState(false);

  const qcApi = useFetchQualificationCriteriaAndPricing(campaign?.id);

  const handleSubmit = async (
    meetingResult: "show" | "no_show",
    qualificationTier?: QualificationTierI
  ) => {
    if (!campaign?.id || !account?.id) {
      return;
    }

    setIsLoading(true);

    try {
      const API = glencocoClientAPI();
      const resp = await swallow(
        API.meetingQualification.submitQualification(campaign.id, account.id, {
          meeting_result: meetingResult,
          qualification_tier: qualificationTier,
        })
      );

      if (resp.status === 200) {
        toast.success(
          meetingResult === "show"
            ? "Meeting marked as Show"
            : "Meeting marked as No-Show"
        );
        onAccountUpdate();
        onClose();
      }
    } catch {
      toast.error("Failed to submit meeting qualification");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-[540px]">
        <DialogHeader>
          <DialogTitle>Mark meeting outcome</DialogTitle>

          <DialogDescription>
            Select the outcome of this meeting.
          </DialogDescription>
        </DialogHeader>

        <MarkMeetingForm
          qcData={qcApi.data}
          isQCLoading={qcApi.isLoading}
          isLoading={isLoading}
          onSubmit={handleSubmit}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
